'use strict';

var _ = require('lodash');
var CompetitorFaresCommonService = function CompetitorFaresCommonService($q, dataRetrieverConstantsService, dataRetrieverService) {
  function isSingleServiceSelected(selectedServices) {
    return selectedServices.length === 1;
  }
  function isSingleService(availableServices, selectedServices) {
    return isSingleServiceSelected(selectedServices) || availableServices.length === 1;
  }
  function getOriginAndDestination(screen, dataRetriever, selectedEntity) {
    if (screen === dataRetrieverConstantsService.FLIGHT_SCREEN) {
      var legToSplit = selectedEntity ? _.get(selectedEntity, 'leg') : _.get(dataRetriever.brushFilters(), 'flightLevel.secondaryData[0].leg');
      return legToSplit.split('-');
    } else if (screen === dataRetrieverConstantsService.MARKET_SCREEN && !_.isArray(dataRetriever.customSearchCriteria)) {
      return dataRetriever.customSearchCriteria.split('((market==\'')[1].split('\';')[0].split('-');
    } else {
      return _.find(dataRetriever.customSearchCriteria, ['field', 'market']).leftOperand.split('-');
    }
  }
  function isFilterTimeWindowOnly(filter) {
    return filter.display === 'timeWindowCompFares';
  }
  function cloneDataRetriever(screen, mode) {
    var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService[screen], mode);
    var clonedDataRetriever = _.cloneDeep(dataRetriever);
    clonedDataRetriever.defaultSortDefer = $q.all();
    clonedDataRetriever.defaultSortCriteriaPromise = clonedDataRetriever.defaultSortDefer.promise;
    return clonedDataRetriever;
  }
  return {
    getOriginAndDestination: getOriginAndDestination,
    isSingleService: isSingleService,
    isSingleServiceSelected: isSingleServiceSelected,
    isFilterTimeWindowOnly: isFilterTimeWindowOnly,
    cloneDataRetriever: cloneDataRetriever
  };
};
CompetitorFaresCommonService.$inject = ['$q', 'DataRetrieverConstantsService', 'DataRetrieverService'];
module.exports = CompetitorFaresCommonService;